import type { DailyChallengeFetchResult, DailyChallengeResponse } from '@/types/dailyChallenge';

export async function fetchDailyChallenge(date?: string): Promise<DailyChallengeFetchResult> {
  try {
    const url = new URL('/api/daily-challenge', window.location.origin);
    if (date) {
      url.searchParams.set('date', date);
    }

    const response = await fetch(url.toString(), { method: 'GET' });
    if (!response.ok) {
      const body = await response.json().catch(() => null) as {
        error?: string;
        currentDate?: string;
        requestedDate?: string;
      } | null;
      if (body?.error === 'challenge_expired') {
        return {
          ok: false,
          error: 'challenge_expired',
          currentDate: body.currentDate,
          requestedDate: body.requestedDate ?? date,
        };
      }
      return { ok: false, error: 'request_failed' };
    }

    const data = (await response.json()) as DailyChallengeResponse;
    return { ok: true, data };
  } catch {
    return { ok: false, error: 'request_failed' };
  }
}
